import { InjectionToken } from '@angular/core';

export const SENTRY = new InjectionToken<SentryErrors>('snack.sentry.token');
export const SENTRY_TRACING = new InjectionToken<SentryErrors>('snack.sentry.tracing.token');

export interface SentryErrors {
  captureException(e);
  setUser(data);
  configureScope(scope);
  setContext(key, data);
}
